import { PaymentEvent } from './event';

export const paymentModalClose = () => {
  const event = new PaymentEvent('payment-cancel');

  event.dispatch();
};
